import React from 'react';
import { IconProps } from '.';

type ForbiddenIconProps = {
  color?: string;
} & IconProps;

export const ForbiddenIcon: React.FC<ForbiddenIconProps> = ({
  width = 24,
  height = 24,
  color = '#D0D0D0',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 10 10"
    >
      <circle cx="5" cy="5" r="4.5" stroke={color}></circle>
      <path stroke={color} d="M1.778 1.757l6.19 6.19"></path>
    </svg>
  );
};
